export const corporate = {
  "hero": {
    "title": "Acerca de VIAJES EN BURRO",
    "subtitle": "Descubre nuestra historia, nuestra visión y el apasionado equipo que está reinventando el intercambio de casas para los anfitriones más exigentes."
  },
  "mission": {
    "badge": "Nuestra Misión",
    "title": "democratizando los viajes premium entre pares",
    "description": "DONKEY TRAVEL se creó con una ambición simple: permitir que los mejores huéspedes también disfruten de los frutos de su trabajo. Creemos que los propietarios de viviendas excepcionales, con una calificación de 4,5 o superior, merecen una plataforma dedicada donde puedan comercializar sus propiedades con confianza, sin la fricción financiera de los alquileres tradicionales."
  },
  "philosophy": {
    "badge": "Filosofía y Valores",
    "title": "En el corazón de nuestro club",
    "description": "No somos sólo una plataforma, somos una comunidad basada en la confianza, el respeto mutuo y la excelente hospitalidad.",
    "values": {
      "fair": {
        "title": "Equidad",
        "desc": "Nuestro sistema comercial está diseñado para ser justo y transparente. Ofreces tiempo en tu alojamiento, ahorras tiempo para viajar. Es simple, sin cargos ocultos."
      },
      "local": {
        "title": "Inmersión",
        "desc": "El intercambio de casas es la oportunidad de vivir como un local, descubrir regiones fuera de lo común y crear conexiones auténticas."
      },
      "community": {
        "title": "Confianza",
        "desc": "Al reservar nuestro club para huéspedes con una calificación de 4,5+, garantizamos un nivel impecable de exigencia y calidad dentro de nuestra red."
      }
    }
  },
  "team": {
    "badge": "el equipo",
    "title": "Detrás de VIAJES EN BURRO",
    "subtitle": "Una plataforma nacida de la pasión por los viajes y la hospitalidad.",
    "members": {
      "ceo": {
        "name": "Sylvain",
        "role": "Fundador y director ejecutivo",
        "bio": "Sylvain, apasionado anfitrión desde hace años, imaginó DONKEY TRAVEL solo, buscando una solución para viajar gratis y al mismo tiempo promocionar su propio alojamiento. Impulsado por el deseo de crear el mejor club de intercambio europeo, vela cada día por la excelencia de la comunidad."
      }
    }
  },
  "investors": {
    "badge": "Inversores y socios",
    "title": "Únete a la aventura",
    "description": "DONKEY TRAVEL está creciendo y siempre estamos abiertos a oportunidades estratégicas para acelerar nuestro desarrollo en toda Europa.",
    "cta": "Contáctenos"
  }
};
